import { shape, string, number, arrayOf } from 'prop-types';

export const currentOrderPropTypes = shape({
  id: number,
  orderId: number,
  dispatchMethod: string,
  status: string,
  totalPrice: number,
  items: arrayOf(
    shape({
      id: number,
      price: number,
      quantity: number,
      name: string,
      variantName: string
    })
  )
});

export const lastOrderPropTypes = shape({
  id: number,
  orderId: number,
  dispatchMethod: string,
  status: string,
  storeName: string,
  totalPrice: number,
  storeId: number,
  items: arrayOf(
    shape({
      id: number,
      price: number,
      quantity: number,
      name: string,
      variantName: string
    })
  )
});

export const pastOrderPropTypes = shape({
  id: number,
  createdAt: string,
  totalPrice: number,
  page: arrayOf(
    shape({
      id: number,
      name: string,
      quantity: number,
      variantName: string,
      pictures: arrayOf(
        shape({
          url: string
        })
      )
    })
  )
});

export const giftCardItemPropTypes = shape({
  amount: number,
  buyer: shape({
    name: string,
    email: string
  }),
  receiver: shape({
    name: string,
    email: string
  })
});
